import _ from 'underscore';
import { odata } from '@bingads-webui/http-util';

export class StockImageDataService {
  constructor({
    cid,
    aid,
    oDataConfig,
    controller,
  }) {
    this.cid = cid;
    this.aid = aid;
    this.path = oDataConfig.odataPath;
    this.controller = controller || 'Images';
    this.oDataConfig = {
      oDataToken: oDataConfig.odataToken,
      oDataTokenType: oDataConfig.oDataTokenType,
      applicationName: oDataConfig.applicationName,
    };
    this.odata = odata;
  }

  /**
   * Get the stock images using the OData
   *
   * @param {Object} options - options for getting
   * @param {Number} options.top - top
   * @param {Number} options.skip - skip
   * @param {Object} options.customQueries - key value pair for the additional queries.
   *
   * @returns {Promise} - Promise of getting the images
   */
  getStockImages(options) {
    const defaultOptions = {
      top: 20,
      skip: 0,
      customQueries: {},
    };

    const optionsWithDefault = _.defaults(options, defaultOptions);

    const url = `${this.path}/Customers(${this.cid})/Accounts(${this.aid})/${this.controller}`;

    const query = _.extend({
      $top: optionsWithDefault.top,
      $skip: optionsWithDefault.skip,
    }, optionsWithDefault.customQueries);

    return this.odata.get(url, _.extend({ data: query }, this.oDataConfig));
  }

  /**
   * Save the stock image using the OData
   *
   * @param {Object} options - options for saving
   * @param {string} options.stockImageId - the id of the stock image to save
   * @param {string} options.stockImageVendorId - the id of the stock vendor
   * @returns {Promise} - Promise of saving the images
   */
  saveStockImage({ stockImageId, stockImageVendorId }) {
    const url = `${this.path}/Customers(${this.cid})/Accounts(${this.aid})/${this.controller}`;

    return this.odata.post(
      url,
      _.extend({
        data: {
          Id: stockImageId.toString(),
          StockImageVendor: stockImageVendorId,
        },
      }, this.oDataConfig)
    );
  }
}
